import { Link } from 'react-router-dom';
import { rankingVideos } from '@/mocks/videos';

export default function RankingSection() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-100">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 rounded-full bg-foreground-600"></div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            热播排行
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {rankingVideos.map((video, idx) => (
          <Link
            key={video.id}
            to={`/article/${video.id}`}
            className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-primary-50/50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
          >
            <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center">
              {idx < 3 ? (
                <span
                  className={`text-sm md:text-base font-bold font-heading ${
                    idx === 0
                      ? 'text-primary-500'
                      : idx === 1
                        ? 'text-accent-500'
                        : 'text-secondary-600'
                  }`}
                >
                  {idx + 1}
                </span>
              ) : (
                <span className="text-sm font-medium text-foreground-400">
                  {idx + 1}
                </span>
              )}
            </div>

            <div className="flex-shrink-0 w-16 h-20 rounded-md overflow-hidden bg-background-200">
              <img
                src={video.image}
                alt={video.title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{video.category}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-foreground-400">{video.duration}</span>
              </div>
              <div className="flex items-center gap-1.5 mt-1.5">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs font-medium text-foreground-600">{video.rating}</span>
                <span className="text-xs text-foreground-400 ml-auto">
                  {video.views > 10000
                    ? `${(video.views / 10000).toFixed(0)}万次播放`
                    : `${video.views}次播放`}
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-sm ml-0.5"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}